import { useEffect, useState } from 'react';
import useAuth from 'src/hooks/useAuth';
import { CHAMADOS_CONFIG_DESIGN as D } from './ChamadosConfig.design';
import CaixasEntradaTab from './CaixasEntradaTab';
import { actionListaCaixasEntrada } from 'src/actions/chamados/actionChamadosConfig';

export default function ChamadosConfigComponent() {
  const { user } = useAuth();
  const [listaCaixas, setListaCaixas] = useState([]);
  const [createRequest, setCreateRequest] = useState(false);

  async function buscarCaixas() {
    try {
      const response = await actionListaCaixasEntrada(`?cliente_id=${user.clienteId}`);
      setListaCaixas(response.data.data);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    buscarCaixas();
  }, []);

  return (
    <div className={D.root} style={{ fontFamily: D.fontStack }}>
      <div className={D.stickyHeader}>
        <div className={D.container}>
          <div className={D.topbar}>
            <div className={D.topbarIdentity}>
              <div className="min-w-0">
                <h1 className={D.title}>Chamados</h1>
                <p className={D.subtitle}>
                  Organize as caixas de entrada. Status e prioridades ficam dentro de cada caixa.
                </p>
              </div>
            </div>
            <div className={D.topbarActions}>
              <button type="button" onClick={() => setCreateRequest(true)} className={D.primaryButton}>
                Criar caixa
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className={`${D.container} pt-6 ${D.pageBody}`}>
        <CaixasEntradaTab
          listaCaixas={listaCaixas}
          onRefresh={buscarCaixas}
          clienteId={user.clienteId}
          createRequest={createRequest}
          onCreateRequestHandled={() => setCreateRequest(false)}
        />
      </div>
    </div>
  );
}
